'use strict'

import Blog from '@/components/blog/Blog'
import BlogCategory from '@/components/blog/BlogCategory'
import Category from '@/components/Category'
import CategoryEntry from '@/components/CategoryEntry'
import ChangePassword from '@/components/change_password/ChangePassword'
import CreatePassword from '@/components/create_password/CreatePassword'
import CorrectPassword from '@/components/correct_password/CorrectPassword'
import Dashboard from '@/components/dashboard/Dashboard'
import DashboardCommunity from '@/components/dashboard/DashboardCommunity'
import DashboardAddresses from '@/components/dashboard/DashboardAddresses'
import DashboardPassword from '@/components/dashboard/DashboardPassword'
import DashboardResources from '@/components/dashboard/DashboardResources'
import DashboardCecs from '@/components/dashboard_cecs/DashboardCecs'
import DashboardDocuments from '@/components/dashboard/DashboardDocuments'
import DashboardContacts from '@/components/dashboard/DashboardContacts'
import DashboardIndex from '@/components/dashboard/DashboardIndex'
import DashboardLogout from '@/components/dashboard/DashboardLogout'
import DashboardRegistry from '@/components/dashboard/DashboardRegistry'
import DashboardBenefits from '@/components/dashboard/DashboardBenefits'
import DashboardCertificates from '@/components/dashboard/DashboardCertificates'
import DashboardSecureRC from '@/components/dashboard/DashboardSecureRC'
import DesarrolloEmpresarial from '@/components/desarrollo_empresarial/DesarrolloEmpresarial'
import DiscountType from '@/components/discounts/DiscountType'
import Discounts from '@/components/discounts/Discounts'
import Entry from '@/components/Entry'
import Faqs from '@/components/Faqs'
import LearningCenter from '@/components/LearningCenter'
import Lopd from '@/components/lopd/Lopd'
import NewsEntry from '@/components/NewsEntry'
import Post from '@/components/blog/Post'
import RecoverPassword from '@/components/recover_password/RecoverPassword'
import RegisterForm from '@/components/register/RegisterForm'
import RegisterOk from '@/components/register/RegisterOk'
import RegisterLanding from '@/components/register/RegisterLanding'
import RegisterSection from '@/components/register/RegisterSection'
// new register
import RegisterPacks from '@/components/register/RegisterPacks'
import RegisterStep1 from '@/components/register/RegisterStep1'
import RegisterStep2 from '@/components/register/RegisterStep2'
import RegisterStep3 from '@/components/register/RegisterStep3'
import RegisterSelectPack from '@/components/register/RegisterSelectPack'
import RegisterFinish from '@/components/register/RegisterFinish'
// end new register
import Resources from '@/components/resources/Resources'
import ResourcesEntrada from '@/components/resources/ResourcesEntrada'
import ResourcesType from '@/components/resources/ResourcesType'
import Root from '@/components/Root'
import Router from 'vue-router'
import SchoolAdmin from '@/components/school_admin/SchoolAdmin'
import SchoolAdminCecs from '@/components/school_admin_cecs/SchoolAdminCecs'
import SchoolAdminLogout from '@/components/school_admin_logout/SchoolAdminLogout'
import SchoolAdminMigration from '@/components/school_admin_migration/SchoolAdminMigration'
import SchoolAdminVerification from '@/components/school_admin_migration/SchoolAdminVerification'
import SchoolAdminMigrationPreview from '@/components/school_admin_migration_preview/SchoolAdminMigrationPreview'
import SchoolAdminProfessionals from '@/components/school_admin_professionals/SchoolAdminProfessionals'
import SportsFacilities from '@/components/sports_facilities/SportsFacilities'
import SportsFacilitiesList from '@/components/sports_facilities_list/SportsFacilitiesList'
import TrainerList from '@/components/TrainerList'
import TrainerView from '@/components/TrainerView'
import LoginView from '@/components/LoginView'
import Benefits from '@/components/benefits/Benefits'
import BenefitsPack from '@/components/benefits/BenefitsPack'
import ResourcesCovid from '@/components/resources_covid/ResourcesCovid'
import Welcome from '@/components/Welcome'
import AddLogo from '@/components/AddLogo'

import ProfileView from '@/components/ProfileView'
import ProfileVCardLinks from '@/components/ProfileVCardLinks'
import ProfileVCardAppearance from '@/components/ProfileVCardAppearance'
import ProfileVCardSocial from '@/components/ProfileVCardSocial'
import ExploreLinks from '@/components/explore_links/ExploreLinks'

import Vue from 'vue'

Vue.use(Router)

let professionalRestricted = (to, from, next) => {
  if (/^\/dashboard.*/.test(to.path)) {
    // Trying to access dashboard, security check
    if (!localStorage.getItem(window.PREFIX + "token")) {
      // forbidden
      return next({ name: 'Root' })
    }

    // Only allowed for professionals
    if (localStorage.getItem(window.PREFIX + "type" != 'professional')) {
      return next({ name: 'SchoolAdmin' })
    }
  }
  next()
}

let schoolRestricted = (to, from, next) => {
  if (/^\/school-admin.*/.test(to.path)) {
    // Trying to access dashboard, security check
    let ls = localStorage

    if (!ls.getItem(window.PREFIX + "token")) {
      // forbidden
      return next({ name: 'Root' })
    }

    // Only allowed for professionals
    if (ls.getItem(window.PREFIX + "type") == 'professional') {
      return next({ name: 'DashboardIndex' })
    }
  }

  next()
}

export default new Router({
  mode: 'history',
  routes: [
    // Content
    {
      path: '/',
      redirect: "/conectar"
    },
    {
      path: '/preguntas-frecuentes',
      name: 'Faqs',
      component: Faqs,
    },
    {
      path: '/conectar',
      name: 'LoginView',
      component: LoginView,
    },
    {
      path: '/centro-de-aprendizaje',
      name: 'LearningCenter',
      component: LearningCenter,
    },
    {
      path: '/noticia/:slug',
      name: 'NewsEntry',
      component: NewsEntry,
    },
    {
      path: '/recuperar-contrasena',
      name: 'RecoverPassword',
      component: RecoverPassword,
    },
    {
      path: '/cambiar-contrasena/:uuid',
      name: 'ChangePassword',
      component: ChangePassword,
    },
    {
      path: '/crear-contrasena',
      name: 'CreatePassword',
      component: CreatePassword,
    },
    {
      path: '/contrasena-creada',
      name: 'CorrectPassword',
      component: CorrectPassword,
    },
    {
      path: '/recursos',
      name: 'Resources',
      component: Resources,
    },
    {
      path: '/recursos/:slug',
      props: true,
      name: 'ResourcesType',
      component: ResourcesType,
    },
    {
      path: '/recursos/entrada-recurso/:slug',
      props: true,
      name: 'ResourcesEntrada',
      component: ResourcesEntrada,
    },
    {
      path: '/descuentos',
      name: 'Discounts',
      component: Discounts,
    },
    {
      path: '/descuentos/:slug',
      props: true,
      name: 'DiscountType',
      component: DiscountType,
    },
    {
      path: '/instalaciones-deportivas/:slug',
      props: true,
      name: 'SportsFacilities',
      component: SportsFacilities,
    },
    {
      path: '/instalaciones-deportivas',
      name: 'SportsFacilitiesList',
      component: SportsFacilitiesList,
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
    },
    {
      path: '/blog/contenido/:slug',
      props: true,
      name: 'Post',
      component: Post,
    },
    {
      path: '/blog/categoria/:slug',
      props: true,
      name: 'BlogCategory',
      component: BlogCategory,
    },
    // Register
    {
      path: '/loginToCommunity',
      name: 'DashboardCommunity',
      component: DashboardCommunity,
    },
    {
      path: '/registro/seleccion',
      name: 'RegisterLanding',
      component: RegisterLanding,
    },
    {
      path: '/registro/:type',
      name: 'RegisterSection',
      component: RegisterSection,
    },
    {
      path: '/formulario-registro/:type',
      name: 'RegisterForm',
      component: RegisterForm,
    },
    {
      path: '/registro-correcto',
      name: 'RegisterOk',
      component: RegisterOk,
    },
    {
      path: '/entrada/:slug/:childSlug',
      name: 'ContentCategory',
      props: true,
      component: Category,
    },
    {
      path: '/desarollo-empresarial',
      name: 'DesarrolloEmpresarial',
      component: DesarrolloEmpresarial,
    },
    {
      path: '/pagina/:slug',
      name: 'ContentEntry',
      props: true,
      component: Entry,
    },
    // New Register
    {
      path: '/registro-profesional/packs',
      redirect: "/registro-profesional/selecciona-pack",
    },
    {
      path: '/registro-profesional/paso1',
      name: 'RegisterStep1',
      component: RegisterStep1,
    },
    {
      path: '/registro-profesional/paso2',
      name: 'RegisterStep2',
      component: RegisterStep2,
    },
    {
      path: '/registro-profesional/paso3',
      name: 'RegisterStep3',
      component: RegisterStep3,
    },
    {
      path: '/registro-profesional/selecciona-pack',
      name: 'RegisterSelectPack',
      component: RegisterSelectPack,
    },
    {
      path: '/registro-profesional/final',
      name: 'RegisterFinish',
      component: RegisterFinish,
    },
    // Lists and directories
    {
      path: '/busqueda-de-entrenadores',
      name: 'TrainerList',
      component: TrainerList,
    },
    {
      path: '/busqueda-de-entrenadores/localidad/:encodedCity',
      props: true,
      name: 'TrainerListByCity',
      component: TrainerList,
    },
    {
      path: '/busqueda-de-entrenadores/nombre/:encodedName',
      props: true,
      name: 'TrainerListByName',
      component: TrainerList,
    },
    {
      path: '/e/:id',
      props: true,
      name: 'TrainerView',
      component: TrainerView,
    },
    {
      path: '/beneficios',
      name: 'Benefits',
      component: Benefits,
    },
    {
      path: '/beneficios-paquete',
      name: 'BenefitsPack',
      component: BenefitsPack,
    },
    {
      path: '/recursos-protocolos-covid-19-gimnasios',
      name: 'ResourcesCovid',
      component: ResourcesCovid,
    },
    {
      path: '/bienvenido',
      name: 'Welcome',
      component: Welcome,
      beforeEnter: professionalRestricted,
    },
    {
      path: '/mostrar-logotipo',
      name: 'AddLogo',
      component: AddLogo,
    },
    // Dashboards
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: professionalRestricted,
      children: [
        {
          path: 'indice',
          name: 'DashboardIndex',
          component: DashboardIndex,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'lopd',
          name: 'Lopd',
          component: Lopd,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'desconectar',
          name: 'DashboardLogout',
          component: DashboardLogout,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'documentos',
          name: 'DashboardDocuments',
          component: DashboardDocuments,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'contactos',
          name: 'DashboardContacts',
          component: DashboardContacts,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'registro',
          name: 'DashboardRegistry',
          component: DashboardRegistry,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'datos-contacto',
          name: 'DashboardAddresses',
          component: DashboardAddresses,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'datos-perfil',
          name: 'DashboardProfile',
          component: TrainerView,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'cambiar-password',
          name: 'DashboardPassword',
          component: DashboardPassword,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'recursos-dashboard',
          name: 'DashboardResources',
          component: DashboardResources,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'datos-academicos',
          name: 'DashboardCecs',
          component: DashboardCecs,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'beneficios',
          name: 'DashboardBenefits',
          component: DashboardBenefits,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'certificados',
          name: 'DashboardCertificates',
          component: DashboardCertificates,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'seguro-rc',
          name: 'DashboardSecureRC',
          component: DashboardSecureRC,
          beforeEnter: professionalRestricted,
        },
      ],
    },
    {
      path: '/school-admin',
      name: 'SchoolAdmin',
      component: SchoolAdmin,
      beforeEnter: schoolRestricted,
      children: [
        {
          path: 'migration-escuela',
          name: 'SchoolAdminMigration',
          component: SchoolAdminMigration,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'verification-escuela',
          name: 'SchoolAdminVerification',
          component: SchoolAdminVerification,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'migration-escuela-preview',
          name: 'SchoolAdminMigrationPreview',
          component: SchoolAdminMigrationPreview,
          beforeEnter: schoolRestricted,
        },
        {
          path: 'cecs-escuelas',
          name: 'SchoolAdminCecs',
          component: SchoolAdminCecs,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'desconectar-escuela',
          name: 'SchoolAdminLogout',
          component: SchoolAdminLogout,
          beforeEnter: professionalRestricted,
        },
        {
          path: 'profesioanles',
          name: 'SchoolAdminProfessionals',
          component: SchoolAdminProfessionals,
          beforeEnter: professionalRestricted,
        },
      ],
    },
    {
      path: '/vcard/:id',
      props: true,
      name: 'ProfileView',
      component: ProfileView,
    },
    {
      path: '/vcard-enlaces',
      name: 'ProfileVCardLinks',
      component: ProfileVCardLinks,
      beforeEnter: professionalRestricted,
    },
    {
      path: '/vcard-apariencia',
      name: 'ProfileVCardAppearance',
      component: ProfileVCardAppearance,
      beforeEnter: professionalRestricted,
    },
    {
      path: '/vcard-redessociales',
      name: 'ProfileVCardSocial',
      component: ProfileVCardSocial,
      beforeEnter: professionalRestricted,
    },
    {
      path: '/explorar-enlaces',
      name: 'ExploreLinks',
      component: ExploreLinks,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js